/* 甘寧傳・第 3 章：皖城・升城督（建安十九年，214）
 * 史實：〈甘寧傳〉正文：「後從攻皖，爲升城督。寧手持練，身緣城，爲吏士先，卒破獲朱光。計功，呂蒙爲最，寧次之，拜折衝將軍。」
 *       〈呂蒙傳〉正文：「蒙乃薦甘寧爲升城督，督攻在前，蒙以精銳繼之。侵晨進攻，蒙手執枹鼓，士卒皆騰踴自升，食時破之。
 *       既而張遼至夾石，聞城已拔，乃退。」注引《吳書》：呂蒙說「乘雨水以入，若留經日，水必向盡，還道艱難」，主張四面並攻、不造土山。
 * 流程：1. 侵晨：涉過城南被雨水漫過的低地（甘寧在水裡，Q 錦帆打到的人都會擊飛），到南牆下站定「緣城」——城上會丟石頭，挨打就要重來。
 *       2. 爬上城、吏士隨後：殺到南門內側，打開城門。
 *       3. 呂蒙擊鼓、吳兵騰踴而入；攻進太守府，朱光生命壓到三成以下就投降（破獲朱光）。
 *       拖過「食時」張遼的援軍就到了：失敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, rout, TROOPS } from '../kit.ts';
import { GN_PEOPLE } from './ganning_kit.ts';
import { CITY, GATE, FU, CAMP, CLIMB, WALL_S } from '../maps/ganning_wan.ts';

const LV = 13, LIMIT = 240, MEAL = 150;
const WEI = { spec: TROOPS.wei, name: '曹兵', hp: 460, maxHp: 460, atk: 26, ms: 245 };
const inside = (u) => Math.abs(u.x - CITY.x) < CITY.hw - 20 && u.y < WALL_S - 20 && u.y > CITY.y - CITY.hh + 20;

export default {
  id: 'ganning-3', map: 'ganning_wan', hero: 'ganning',
  title: '第 3 章　皖城・升城督', year: '建安十九年（214）',
  brief: {
    quote: [{ text: '寧手持練，身緣城，爲吏士先，卒破獲朱光。', src: '《三國志·吳書·甘寧傳》' }],
    text: '曹操派朱光當廬江太守，屯在皖城大開稻田。呂蒙勸孫權趁雨水還在、外援未到，四面急攻。呂蒙推薦甘寧當「升城督」，帶頭爬城。',
    goals: ['到南牆下緣城（城上會丟石頭）', '打開南門', '破獲朱光', `食時之前（${LIMIT} 秒）拿下皖城`],
  },
  words: { ally: '吏士', foe: '曹兵' },
  stars: [
    { text: `如史：食時破之——${MEAL} 秒內拿下皖城`, ok: (m) => m.vars.doneT != null && m.vars.doneT <= MEAL },
    { text: '緣城一次就爬上去（沒被打斷）', ok: (m) => !m.vars.broke },
    { text: '爲吏士先：開城門前斬殺 10 人以上', ok: (m) => m.vars.first >= 10 },
  ],
  steps: [
    { // 1. 侵晨：涉水到城下，緣城
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        V.t0 = w.t; V.broke = 0; V.stoneT = 2;
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 90 - (i % 3) * 50, me.y - 70 + Math.floor(i / 3) * 140, '吏士'); m.join(u, me); return u; });
        V.lm = ally(w, 'lvmeng', CAMP[0] - 200, CAMP[1] - 200, LV); V.lm.hold = [CAMP[0] - 200, CAMP[1] - 400];
        // 城南水裡的哨兵
        V.out = [[2700, 2880], [3000, 2900], [4200, 2880], [4500, 2900], [3400, 3240], [3800, 3240]].map(([x, y]) => m.foe('huangjin', x, y, WEI));
        // 城裡：南門內側的守兵、太守府
        V.gateGuard = Array.from({ length: 7 }, (_, i) => m.foe('huangjin', GATE[0] - 300 + i * 100, WALL_S - 220 - (i % 2) * 90, WEI));
        V.zg = boss(w, GN_PEOPLE.zhuguang, FU[0], FU[1], { name: '朱光', hp: 3600, atk: 48, armor: 8, ms: 220 });
        V.fu = m.camp(FU[0], FU[1] + 40, [['huangjin', 6]], 240).map((u) => Object.assign(u, WEI, { hp: 460, maxHp: 460 }));
        m.gate('s', GATE[0], GATE[1], 170, 'citygate');
        CLIMB.forEach(([x, y], k) => m.mark('c' + k, x, y + 90, '緣城', true));
        m.card('侵晨進攻。', '《呂蒙傳》');
        m.after(2, () => m.line('呂蒙', '興霸當升城督，在前登城；蒙以精銳隨後！'));
        m.after(5, () => m.line('提示', '城南的低地被雨水漫過，甘寧在水裡時 Q 錦帆打到的人都會擊飛。到南牆下的「緣城」處站定不動就會爬城；城上會丟石頭（紅圈），挨打就要重來——看準石頭落下後的空檔再爬。'));
        m.obj('climb', '手持練，身緣城');
        m.obj('time', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 城上丟石頭：人到了南牆下
        V.stoneT -= dt;
        if (V.stoneT <= 0 && me.y > WALL_S && me.y < WALL_S + 700) { V.stoneT = 5.5; m.strike(me.x + (SG.rand() - 0.5) * 60, me.y + (SG.rand() - 0.5) * 40, 115, 1.2, 80, 0); } // 一輪一輪地丟：看準落下後的空檔再爬
        CLIMB.forEach(([x, y], k) => m.chanAt(me, 'c' + k, x, y + 90, 150, 3, '緣城', () => {
          V.climbed = k;
          me.x = x; me.y = WALL_S - 120;
          m.after(2, () => { for (const u of m.alive(V.men)) { const p = SG.MAP.nearestFree(x + (SG.rand() - 0.5) * 200, WALL_S - 160); u.x = p[0]; u.y = p[1]; } m.line('吏士', '督將上去了！跟上！'); });
        }, { fail: (why) => { if (why === '中斷') V.broke++; } }));
        return V.climbed != null;
      },
    },
    { // 2. 打開南門
      enter(m, w) {
        const V = m.vars;
        m.done('climb'); CLIMB.forEach((_, k) => m.unmark('c' + k));
        m.card('寧手持練，身緣城，爲吏士先。', '《甘寧傳》');
        m.mark('gate', GATE[0], WALL_S - 230, '南門');
        m.obj('gate', '殺到南門內側，打開城門');
        V.slain0 = m.stats.slain;
        for (const u of V.gateGuard) u.home = [w.player.x, w.player.y];
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.chanAt(me, 'gate', GATE[0], WALL_S - 230, 170, 3, '開城門', () => { V.open = true; });
        return !!V.open;
      },
    },
    { // 3. 蒙手執枹鼓：攻太守府
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.first = m.stats.slain;
        m.done('gate'); m.unmark('gate');
        m.ungate('s');
        m.card('蒙手執枹鼓，士卒皆騰踴自升。', '《呂蒙傳》');
        V.lm.hold = null; V.lm.x = GATE[0]; V.lm.y = GATE[1] + 200;
        V.wu = Array.from({ length: 12 }, (_, i) => { const u = m.recruit(GATE[0] - 150 + (i % 4) * 100, GATE[1] + 150 + Math.floor(i / 4) * 80, '吳兵'); m.join(u, me); return u; });
        for (const u of V.wu.concat(m.alive(V.men), [me, V.lm])) w.addBuff(u, { id: '枹鼓', t: 9999, atkP: 0.2 });
        m.mark('zg', FU[0], FU[1], '朱光', false, V.zg);
        m.obj('zg', '破獲朱光');
        m.after(2, () => m.line('甘寧', '朱光在太守府！拿活的！'));
      },
      tick(m, w) {
        const V = m.vars, zg = V.zg;
        if (!zg.alive) { V.killed = true; return true; }
        if (zg.hp < zg.maxHp * 0.3) { zg.untargetable = true; zg.target = null; zg.home = [zg.x, zg.y]; zg.think = 99; return true; }
        return false;
      },
    },
    { // 4. 食時破之
      enter(m, w) {
        const V = m.vars;
        V.doneT = w.t - V.t0;
        m.done('zg'); m.done('time'); m.unmark('zg');
        rout(m, w, w.units.filter((u) => u.team === 1 && u.alive && u !== V.zg), [CITY.x, 200]);
        m.card(V.killed ? '朱光死於亂軍之中。' : '卒破獲朱光。', '《甘寧傳》');
        m.after(3, () => m.card('食時破之。既而張遼至夾石，聞城已拔，乃退。', '《呂蒙傳》'));
        m.after(7, () => m.card('計功，呂蒙爲最，寧次之，拜折衝將軍。', '《甘寧傳》'));
        m.after(10, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('甘寧陣亡'); return; }
    if (!V.lm) return;
    allyTick(w, V.lm, me);
    if (m.i < 3) {
      const t = w.t - V.t0;
      const o = m.get('time'); if (o) o.text = `食時之前拿下皖城（${Math.max(0, Math.ceil(LIMIT - t))} 秒）`;
      if (t > LIMIT) m.lose('城備既脩，張遼的援軍到了');
    }
  },
};
